import React from "react";
import { useLang } from "@/context/LanguageContext";
import { Target, ShieldCheck, Handshake } from "lucide-react";

const ABOUT_IMG = "https://customer-assets.emergentagent.com/job_circuit-solutions-3/artifacts/83jwhjor_Screenshot%202026-06-25%20163502.png";

export default function About() {
  const { t } = useLang();
  const values = [[Target, "v1t", "v1"], [ShieldCheck, "v2t", "v2"], [Handshake, "v3t", "v3"]];
  return (
    <div data-testid="about-page">
      <section className="border-b border-slate-200 bg-white">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-4 py-16 sm:px-6 lg:grid-cols-2 lg:items-center">
          <div>
            <h1 className="text-4xl font-bold tracking-tight text-slate-950 sm:text-5xl">{t("about.title")}</h1>
            <div className="mt-6 space-y-4 text-base leading-relaxed text-slate-700">
              <p>{t("about.p1")}</p>
              <p>{t("about.p2")}</p>
              <p>{t("about.p3")}</p>
            </div>
          </div>
          <div className="aspect-[4/3] overflow-hidden border border-slate-200 bg-slate-100">
            <img src={ABOUT_IMG} alt="Operator" className="h-full w-full object-cover" />
          </div>
        </div>
      </section>

      <section className="bg-slate-950">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
          <div className="border-l-2 border-blue-500 pl-6">
            <h2 className="text-sm font-bold uppercase tracking-widest text-blue-500">{t("about.missionTitle")}</h2>
            <p className="mt-3 max-w-3xl text-2xl font-bold leading-snug tracking-tight text-white sm:text-3xl">{t("about.mission")}</p>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
        <h2 className="mb-10 text-3xl font-bold tracking-tight text-slate-950">{t("about.valuesTitle")}</h2>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {values.map(([Icon, tt, dd], i) => (
            <div key={i} className="border border-slate-200 bg-white p-8" data-testid={`value-${i}`}>
              <Icon className="mb-4 h-8 w-8 text-blue-700" />
              <h3 className="mb-2 text-lg font-bold tracking-tight text-slate-950">{t(`about.${tt}`)}</h3>
              <p className="text-sm leading-relaxed text-slate-600">{t(`about.${dd}`)}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
